import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-status-bar',
  imports: [MatIconModule, TranslatePipe],
  templateUrl: './status-bar.component.html',
  styleUrl: './status-bar.component.scss'
})
export class StatusBarComponent {
  readonly currentYear: number = new Date().getFullYear();
  // The Edge recommendation is only relevant for non-Edge browsers
  showInfoMessage: boolean = !((globalThis.navigator?.userAgent ?? '').includes('Edg/'));
}
